import React, { useEffect, useState } from 'react';
import Layout from '../../../components/Layout';
import { Box, Typography, useTheme, } from '@mui/material';
import apiClient from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';
import DynamicTable from '../../../components/Table/DataTable';
import { IconActivate, IconClock, IconDeactivate, IconEdit, IconEye, IconMapPin, IconShield } from '../../../components/icons/icons';
import TablePaginationActions from '../../../components/Table/tablePagination';
import LoadingScreen from '../../../components/LoadingScreen';
import SecurityDialog from '../SecurityDialog';

import { StatusModal } from '../ConfirmModal';
import LocationDialog from '../Locationmodal';
import AddVetetinarianModal from './AddVeterinarianModal';
import EditChoiceDialog from '../EditChoiceDialog';

const VeterinarianList = () => {
    const [veterinarians, setVeterinarian] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
    const [totalCount, setTotalCount] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [hasSearched, setHasSearched] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [statusFilter, setStatusFilter] = useState('');
    const [securityDialogOpen, setSecurityDialogOpen] = useState(false);
    const [selectedUserForSecurity, setSelectedUserForSecurity] = useState<any>(null);
    const [locationDialogOpen, setLocationDialogOpen] = useState(false);
    const [selectedUserForLocation, setSelectedUserForLocation] = useState<any>(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [currentUser, setCurrentUser] = useState<any>(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [editChoiceOpen, setEditChoiceOpen] = useState(false);
    const [selectedUserForEdit, setSelectedUserForEdit] = useState<any>(null);
    const fetchVeterinarians = async () => {
        try {
            setLoading(true);
            console.log('searchQuery', searchQuery);
            // Build params object conditionally
            const params: any = {
                limit: rowsPerPage,
                page: page + 1,
                searchkey: searchQuery || "",
                order_by: "id",
                dir: 2,
                type: "all",
                from: "",
                to: "",
            };

            // Only add isActiveUsers if statusFilter is not empty
            if (statusFilter !== "") {
                params.isActiveUsers = statusFilter;
            }

            const queryString = new URLSearchParams(params).toString();
            const { data } = await apiClient(`v1/resource/providers?${queryString}`, { method: "GET" }) as any;

            const veterinariansData = data.providers;
            setVeterinarian(veterinariansData);
            setTotalCount(data.pagination.total);
        } catch (err: any) {
            setError(err.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVeterinarians();
    }, [searchQuery, page, rowsPerPage, statusFilter]);


    const handleAddClick = () => {
        setShowAddModal(true);
    };
    const handleEditClick = (row: any) => {
        setSelectedUserForEdit(row);
        setEditChoiceOpen(true);
    };
    const handleOpenEditUser = () => {
        setEditData(selectedUserForEdit);
        setShowAddModal(true);
    };
    const handleOpenEditLocation = () => {
        setSelectedUserForLocation(selectedUserForEdit.user);
        setLocationDialogOpen(true);
    };
    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (newRowsPerPage: number) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0);
    };

    const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setStatusFilter(e.target.value);
        setPage(0); // reset to first page on filter change
    };
    const filteredveterinarians = veterinarians;

    const columns = [

        {
            key: 'serial',
            label: 'S.No',
            align: 'center',
            render: (_row: any, index: number) => page * rowsPerPage + index + 1,
        },
        {
            key: 'veterinarian',
            label: 'Name',
            align: 'center',
            render: (row: any) => {
                const user = row?.user;
                const firstName = user?.first_name || '';
                const lastName = user?.last_name || '';
                const initials = `${firstName[0] || ''}${lastName[0] || ''}`.toUpperCase();

                // Determine the full image URL
                const baseUrl = "https://a2zschoolfolio.s3.ap-south-1.amazonaws.com/";
                const profileImage = user?.profile_image
                    ? user.profile_image.startsWith('http')
                        ? user.profile_image // already full URL
                        : `${baseUrl}${user.profile_image}` // relative -> full URL
                    : null;

                // Color for initials
                const colors = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#f97316'];
                const colorIndex = user?.username ? user.username.charCodeAt(0) % colors.length : 0;
                const bgColor = colors[colorIndex];

                return (
                    <div className="flex items-center gap-2">
                        {profileImage ? (
                            <img
                                src={profileImage}
                                alt={`${firstName} ${lastName}`}
                                className="w-10 h-10 rounded-full object-cover"
                            />
                        ) : (
                            <div
                                className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold"
                                style={{ backgroundColor: bgColor }}
                            >
                                {initials || '?'}
                            </div>
                        )}
                        <span>{`${firstName} ${lastName}`.trim() || '-'}</span>
                    </div>
                );
            },
        },

        // { key: 'city', label: 'City', align: 'center', render: (row: any) => row?.user?.address?.city || '-' },
        {
            key: 'speciality', label: 'Speciality', align: 'center', render: (row: any) => {
                const specialities = row?.provider_speciality?.map((spec: any) => spec.speciality).join(', ');
                return specialities || '-';
            }
        },
        { key: 'Mobile', label: 'Contact No', align: 'center', render: (row: any) => row?.user?.mobile ?? '-' },
        {
            key: 'Status',
            label: 'Status',
            align: 'center',
            render: (row: any) => {
                let text = 'Inactive';
                let bgColor = '#fee2e2';
                let textColor = '#991b1b';

                if (row?.user?.is_active === 1) {
                    text = 'Active';
                    bgColor = '#d1fae5';
                    textColor = '#065f46';
                } else if (row?.user?.is_active === 2) {
                    text = 'Deactivated';
                    bgColor = '#fef3c7'; // amber background
                    textColor = '#92400e'; // amber text
                }

                return (
                    <span
                        style={{
                            backgroundColor: bgColor,
                            color: textColor,
                            padding: '4px 8px',
                            borderRadius: '6px',
                            fontWeight: 'bold',
                            display: 'inline-block',
                            minWidth: '90px',
                        }}
                    >
                        {text}
                    </span>
                );
            },
        }



    ];

    const getUserStatusInfo = (user: any) => {
        const isActive = user?.is_active === 1;
        return {
            label: isActive ? 'Deactivate' : 'Activate',
            color: isActive ? '#d32f2f' : '#2e7d32',
            icon: isActive ? <IconDeactivate size={20} /> : <IconActivate size={20} />,
            newStatus: isActive ? 2 : 1,
        };
    };

    const handleToggleActive = async (row: any) => {
        const { user } = row;
        const { label, newStatus } = getUserStatusInfo(user);
        const actionName = `${user?.first_name ?? ''} ${user?.last_name ?? ''}`.trim();
        const confirmMsg = `Are you sure you want to ${label} ${actionName}?`;

        if (!window.confirm(confirmMsg)) {
            console.log('❌ Action aborted');
            return;
        }

        const payload = {
            id: row.user_id,
            license_no: row.license_no,
            role: 'veterinarian',
            first_name: user.first_name,
            mobile: user.mobile,
            username: user.username,
            timezone_id: user.timezone?.id,
            is_2fa: user.is_2fa,
            is_active: newStatus || 0,
        };

        console.log('📤 Final Payload Sent:', JSON.stringify(payload, null, 2));

        try {
            const response = await apiClient<any>(`v1/resource/users/${row.user_id}`, {
                method: 'PUT',
                body: payload,
            });

            console.log('✅ Status update success:', response);
            await fetchVeterinarians();
        } catch (error: any) {
            console.error('❌ Error during status update:', error);

            let errorMsg = `Failed to ${label.toLowerCase()} the user.`;

            if (error?.response) {
                const { status, data } = error.response;
                errorMsg += `\n\n🔍 Server responded with status: ${status}`;

                if (data?.message) {
                    errorMsg += `\n📣 Message: ${data.message}`;
                }

                if (data?.data?.errors) {
                    errorMsg += `\n\n❗ Validation Errors:\n`;
                    for (const [field, message] of Object.entries(data.data.errors)) {
                        errorMsg += `- ${field}: ${message}\n`;
                    }
                }

                console.log('🧾 Full Server Error Response:', JSON.stringify(data, null, 2));
            } else {
                errorMsg += `\n\n⚠️ ${error.message || 'Unknown error occurred.'}`;
            }

            alert(errorMsg);
        }
    };
    const handleOpenModal = (user: any) => {
        setCurrentUser(user);
        setModalOpen(true);
    };
    const actions = [
        {
            label: 'View',
            color: '#2196f3',
            icon: <IconEye size={20} />,
            onClick: (row: any) => handleShowDetails(row),
        },
        {
            label: 'Edit',
            color: '#4caf50',
            icon: <IconEdit size={20} />,
            onClick: (row: any) => handleEditClick(row),
        },
        {
            label: "Availability",
            color: "#4caf50",
            icon: <IconClock size={20} />,
            onClick: (row: any) => {
                const providerId = row.id;
                navigate("/availability", {
                    state: { providerId, fromType: "vet" }, // pass fromType here
                });
            },
        },
        {
            label: 'Change Status',
            color: '#1976d2',
            icon: <IconActivate />,
            onClick: (row: any) => handleOpenModal(row),
        },
        {
            label: 'Manage Security',
            color: '#ff9800',
            icon: <IconShield size={20} />,
            onClick: (row: any) => {
                if (!row?.user) return;
                setSelectedUserForSecurity(row.user);
                setSecurityDialogOpen(true); // open the dialog
            }
        },
        // {
        //     label: 'Manage Location',
        //     color: '#009688',
        //     icon: <IconMapPin size={20} />,
        //     onClick: (row: any) => {
        //         if (!row?.user) return;
        //         setSelectedUserForLocation(row.user);
        //         setLocationDialogOpen(true);
        //     }
        // },
    ];


    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            setPage(0);
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchInput]);

    if (loading) return <LoadingScreen message="Loading  Veterinarians..." layout={false} />;

    if (error) {
        return <Typography color="error">Error: {error}</Typography>;
    }


    const handleShowDetails = (item: any) => {
        const id = item.id;

        navigate(`/veterinarians/details/${id}`, {
            state: {
                item,
                fromTab: 'veterinarians',
            },
        });
    };

    const handleSearchClick = () => {
        setSearchQuery(searchInput);
        setPage(0);
        setHasSearched(true);
    };

    const handleClearClick = () => {
        setSearchInput('');
        setSearchQuery('');
        setHasSearched(false);
    };
    return (
        // <Layout>
        <Box >

            <Box
                display="flex"
                flexWrap="wrap"
                gap={2}
                mb={2}
                alignItems="flex-end"
            >

                <div className="flex gap-2 items-end flex-1 min-w-[320px]">
                    <div className="flex-1">
                        <label
                            className="block text-sm font-medium text-gray-700 mb-1"
                            htmlFor=" VeterinarianName"
                        >
                            Veterinarian Name
                        </label>
                        <input
                            id=" VeterinarianName"
                            type="text"
                            placeholder="Search Veterinarian name"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="w-full px-3 py-2 border text-gray-700 border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                        />
                    </div>

                    {hasSearched ? (
                        <button
                            onClick={handleClearClick}
                            className="h-[38px] px-4 bg-gray-500 text-white text-sm rounded-md hover:bg-gray-600"
                        >
                            Clear
                        </button>
                    ) : (
                        <button
                            onClick={handleSearchClick}
                            disabled={!searchInput.trim()}
                            className="h-[38px] px-4 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 disabled:bg-blue-300"
                        >
                            Search
                        </button>
                    )}
                </div>

                {/* Status Filter */}
                <div className="min-w-[180px] flex flex-col">
                    <label
                        htmlFor="status-select"
                        className="block text-sm font-medium text-gray-700 mb-1"
                    >
                        Status
                    </label>
                    <select
                        id="status-select"
                        value={statusFilter}
                        onChange={handleStatusChange}
                        className="w-full px-3 py-2 border border-gray-300 text-gray-700 rounded-md text-sm bg-white focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                    >
                        <option value="">All Status</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                        <option value="2">Deactivated</option>
                    </select>
                </div>


                <div className="flex items-end">
                    <button
                        onClick={handleAddClick}
                        className="h-[38px] px-5 bg-green-600 text-white text-sm font-medium rounded-md hover:bg-green-700"
                    >
                        + Add
                    </button>
                </div>
            </Box>
            <DynamicTable
                columns={columns}
                data={filteredveterinarians}
                loading={loading}
                actions={actions}
                emptyMessage={"No veterinarians found"}
                page={page}
                error={error}
                rowsPerPage={rowsPerPage}
                totalCount={totalCount}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                ActionsComponent={TablePaginationActions}
            />
            <SecurityDialog
                open={securityDialogOpen}
                onClose={() => setSecurityDialogOpen(false)}
                user={selectedUserForSecurity}
                refreshUsers={fetchVeterinarians}
            />
            <LocationDialog
                open={locationDialogOpen}
                onClose={() => setLocationDialogOpen(false)}
                user={selectedUserForLocation}
            />
            <StatusModal
                open={modalOpen}
                currentUser={currentUser}
                onClose={() => setModalOpen(false)}
                onUpdate={fetchVeterinarians}
            />
            {showAddModal && (
                <AddVetetinarianModal
                    mode={editData ? "edit" : "add"}
                    editData={editData}
                    onClose={() => {
                        setShowAddModal(false);
                        setEditData(null);
                    }}
                    onSuccess={() => {
                        setShowAddModal(false);
                        setEditData(null);
                        fetchVeterinarians();
                    }}
                />
            )}
            <EditChoiceDialog
                open={editChoiceOpen}
                onClose={() => setEditChoiceOpen(false)}
                onEditUser={handleOpenEditUser}
                onEditLocation={handleOpenEditLocation}
            />
        </Box>
        // </Layout>
    );
};

export default VeterinarianList;
